var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxBuyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06581 23.7969H14.9642C15.7623 23.7968 16.5491 23.6083 17.2605 23.2465C17.9718 22.8847 18.5877 22.36 19.0578 21.715C19.5279 21.0701 19.839 20.3232 19.9657 19.5352C20.0925 18.7473 20.0312 17.9405 19.787 17.1807L17.6264 10.4607C17.2161 9.18433 16.4114 8.0711 15.328 7.28133C14.2446 6.49156 12.9385 6.06601 11.5979 6.06597H9.43215C8.09147 6.06601 6.78539 6.49156 5.70202 7.28133C4.61865 8.0711 3.81389 9.18433 3.40364 10.4607L1.24301 17.1807C0.998791 17.9405 0.937546 18.7473 1.06426 19.5352C1.19098 20.3232 1.50207 21.0701 1.97219 21.715C2.44231 22.36 3.05816 22.8847 3.76954 23.2465C4.48092 23.6083 5.26772 23.7968 6.06581 23.7969ZM14.3145 1C13.4702 4.37731 12.2037 6.06597 10.515 6.06597C8.82634 6.06597 7.55985 4.37731 6.71552 1H14.3145Z",
    stroke: "#1BA397",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0464 11.1317H9.88021C9.37637 11.1317 8.89316 11.3319 8.53689 11.6881C8.18062 12.0444 7.98047 12.5276 7.98047 13.0315C7.98047 13.5353 8.18062 14.0185 8.53689 14.3748C8.89316 14.7311 9.37637 14.9312 9.88021 14.9312H11.1467C11.6505 14.9312 12.1337 15.1314 12.49 15.4876C12.8463 15.8439 13.0464 16.3271 13.0464 16.8309C13.0464 17.3348 12.8463 17.818 12.49 18.1743C12.1337 18.5305 11.6505 18.7307 11.1467 18.7307H7.98047M10.5135 9.86523V11.1317M10.5135 18.7307V19.9972",
    stroke: "#1BA397",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxBuyer);
export default __webpack_public_path__ + "static/media/taxBuyer.b887a49495a98905a28dfad6bb1beb26.svg";
export { ForwardRef as ReactComponent };